import { Route, useParams } from "react-router-dom";
import { ProjectOverview } from "./Pages/ProjectOverview";
import { ProjectForm } from "./Pages/ProjectForm";
import { SwitchWith404 } from "Config/Router";
import { FilenameConvention } from "./Pages/FilenameConvention";
import { Metadata } from "./Pages/Metadata";
import { ReproService } from "./Pages/ReproService";
import { Views } from "./Pages/Views";
import { Clone } from "./Pages/Clone";
import { PGAdminForm } from "./Pages/PGAdminForm";
import { userInfoStore } from "Stores";
import { Workflows } from "./Pages/Workflows";
import { AutoMapping } from "./Pages/AutoMapping";

export interface ProjectTabProps {
  isEditView: boolean;
}

export const Projects = () => {
  const params = useParams();
  return (
    <SwitchWith404>
      <Route path={`:id/filename-rules`} element={<FilenameConvention />} />
      <Route path={`:id/metadata`} element={<Metadata />} />
      <Route path={`:id/workflows`} element={<Workflows />} />
      <Route path={`:id/views`} element={<Views />} />
      <Route path={`:id/repro-service`} element={<ReproService />} />
      <Route path={`:id/clone`} element={<Clone />} />
      <Route path={`:id/auto-mapping`} element={<AutoMapping />} />
      <Route
        path={`new`}
        element={
          userInfoStore.role === "PRGROUPADMIN" ? (
            <PGAdminForm groupId={params.prGroupId} />
          ) : (
            <ProjectForm isEditMode={false} />
          )
        }
      />
      <Route path={`edit/:id`} element={<ProjectForm isEditMode={true} />} />
      <Route index element={<ProjectOverview prGroupId={params.prGroupId} />} />
    </SwitchWith404>
  );
};
